export const trademarkFilterHelper = (originalString, trademarkList) => {
    try {
        if (Array.isArray(trademarkList) && trademarkList?.length > 0) {
            const list = trademarkList.map(regEx => {
                try {
                    if (regEx === '/(®|™)?/<sup\\>$1\\<\\/sup\\>/gi') {
                        return {
                            // The regex for adding a sup element around the signs fails so we omit it
                            regex: undefined,
                            replacement: undefined,
                        };
                    }
                    return {
                        regex: RegExp(`${regEx.split('/')[1]}`, 'gi'),
                        replacement: `${regEx.split('/')[2]}`,
                    };
                } catch (e) {
                    console.log('Invalid regex:', regEx, e);
                    return {
                        regex: undefined,
                        replacement: undefined,
                    };
                }
            });

            const updatedString = list.reduce((string, {regex, replacement}) => {
                if (regex && typeof string !== 'undefined') {
                    return string.replace(regex, replacement);
                }
                return string;
            }, originalString);

            if (typeof updatedString !== 'undefined') {
                return updatedString
                    .replace(/®/gi, '<sup>®</sup>')
                    .replace(/™/gi, '<sup>™</sup>')
                    .replace(/&reg;/gi, '<sup>®</sup>')
                    .replace(/&trade;/gi, '<sup>™</sup>');
            } else {
                return '';
            }
        }
        return originalString || '';
    } catch (error) {
        console.log('FILTER ERROR', error);
        return originalString;
    }
};